// extracted by mini-css-extract-plugin
export var bodySections = "_e9-8";
export var gray = "_e9-7";
export var green = "_e9-4";
export var iconContainer = "_e9-9";
export var iconWidgetContainer = "_e9-1";
export var phoneIcon = "_e9-2";
export var red = "_e9-5";
export var statusDot = "_e9-3";
export var widgetContainer = "_e9-0";
export var yellow = "_e9-6";